const PALETTE = ["#c7d2fe", "#a5f3fc", "#bbf7d0", "#fed7aa", "#fbcfe8", "#fef08a", "#e9d5ff"];

export function chooseColor(index: number): string {
    return PALETTE[index % PALETTE.length] ?? "#c7d2fe";
}
